import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Водный туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Вид туризма, при котором отдых осуществляется на воде с использованием байдарок, лодок,
                        катамаранов, теплоходов и других плавательных средств.</p>
                    <p>Географически и по времени этот туризм очень разнообразен: от часовых и однодневных маршрутов до
                        многонедельных круизов по морям и океанам. </p>
                </div>
            </div>
        </>
    );
}